import { defineComponent as d, inject as u, h as l } from "vue";
import { colorPickerInjectionKey as p } from "./ghl-ui.es917.js";
import { toHslaString as g } from "./ghl-ui.es904.js";
const m = d({
  name: "ColorPickerTrigger",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    value: {
      type: String,
      default: null
    },
    hsla: {
      type: Array,
      default: null
    },
    disabled: Boolean,
    onClick: Function
  },
  setup(c) {
    const {
      colorPickerSlots: n,
      renderLabelRef: a
    } = u(p, null);
    return () => {
      const {
        hsla: e,
        value: o,
        clsPrefix: r,
        onClick: s,
        disabled: i
      } = c, t = n.label || a.value;
      return l("div", {
        class: [`${r}-color-picker-trigger`, i && `${r}-color-picker-trigger--disabled`],
        onClick: i ? void 0 : s
      }, l("div", {
        class: `${r}-color-picker-trigger__fill`
      }, l("div", {
        class: `${r}-color-picker-checkboard`
      }), l("div", {
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          backgroundColor: e ? g(e) : ""
        }
      }), o && e ? l("div", {
        class: `${r}-color-picker-trigger__value`,
        style: {
          color: e[2] > 50 || e[3] < 0.5 ? "black" : "white"
        }
      }, t ? t(o) : o) : null));
    };
  }
});
export {
  m as default
};
